export default __webpack_public_path__ + "static/media/mojaco_greeting.806725eb.png";